import React from 'react';
const environment = document.location.hostname.match(/meekmeek/) ? 'PROD' : document.location.hostname.match(/vercel/) ? 'PREVIEW': 'DEV';
const Home: React.FC = () => {
    document.title = environment+":Home Page";
  return (
    <div className="home">
      <h1>Home Page</h1>
      <p>Welcome to the home page!</p>
    </div>
  );
};

export default Home;